/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpMobileStarRating_reviews$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpSharedDealerDetailsStats_reviews$ref: FragmentReference;
export type PdpSharedDealerDetailsStats_reviews = {|
  +metadata: ?{|
    +aggregatedFeedback: ?{|
      +overallExperience: ?{|
        +mean: ?number
      |}
    |}
  |},
  +$fragmentRefs: PdpMobileStarRating_reviews$ref,
  +$refType: PdpSharedDealerDetailsStats_reviews$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpSharedDealerDetailsStats_reviews",
  "type": "SellerOrderFeedbackPdpQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpMobileStarRating_reviews",
      "args": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "metadata",
      "storageKey": null,
      "args": null,
      "concreteType": "SellerOrderFeedbackPdpQueryMetadata",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "aggregatedFeedback",
          "storageKey": null,
          "args": null,
          "concreteType": "AggregatedOrderFeedbackType",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "overallExperience",
              "storageKey": null,
              "args": null,
              "concreteType": "AggregatedOrderFeedbackQuestionType",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "mean",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'cca0fba8e7f271c4f129e978d06c84c1';
module.exports = node;
